import { useEffect, useRef, useState } from 'react';

export function useScriptMenu() {
  const [scriptMenuOpen, setScriptMenuOpen] = useState(false);
  const scriptMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scriptMenuOpen) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (scriptMenuRef.current && !scriptMenuRef.current.contains(event.target as Node)) {
        setScriptMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [scriptMenuOpen]);

  return { scriptMenuOpen, scriptMenuRef, setScriptMenuOpen };
}
